var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8,
  height: 8,
  viewBox: "0 0 8 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Path_105",
  "data-name": "Path 105",
  d: "M0,0,8,8H0Z",
  transform: "translate(0 8) rotate(-90)",
  fill: "#eaf0ff"
})));
export default __webpack_public_path__ + "static/media/right-icon.f89a5c08.svg";
export { SvgComponent as ReactComponent };